import axios from 'axios';
import { URLS } from '@constants/urls';
import api from '@helpers/api';
import { generateInstitute } from './mock/institute';

export const getInstitutes = (() => {
  const cancelToken = axios.CancelToken;
  let source = cancelToken.source();
  let isRequestInProcess = false;

  return async (
    page?: number,
    pageSize: number = 10,
  ): Promise<{ data: any }> => {
    if (process.env.REACT_APP_GET_INSTITUTE_DISABLED === 'true') {
      const { result } = generateInstitute(page, pageSize);
      return new Promise((resolve) => {
        setTimeout(
          () =>
            resolve({
              data: result,
            }),
          1000,
        );
      });
    } else {
      if (isRequestInProcess) {
        source.cancel();
        source = cancelToken.source();
      }

      isRequestInProcess = true;
      return api
        .get(URLS.GET_INSTITUTES)
        .then((response) => {
          return { data: response };
        })
        .finally(() => {
          isRequestInProcess = false;
        });
    }
  };
})();

export const updateInstitute = (() => {
  const cancelToken = axios.CancelToken;
  let source = cancelToken.source();
  let isRequestInProcess = false;

  return async ({
    data,
    uuid,
  }: any): Promise<{
    data: any;
  }> => {
    if (isRequestInProcess) {
      source.cancel();
      source = cancelToken.source();
    }

    isRequestInProcess = true;
    return api
      .put(
        URLS.UPDATE_INSTITUTES({
          uuid,
        }),
        { ...data },
      )
      .then((response) => {
        return { data: response.data };
      })

      .finally(() => {
        isRequestInProcess = false;
      });
  };
})();
